import { useEffect, useMemo, useState, useContext } from "react";
import { getFormularioById, enviarFormulario } from "./formularioService";
import { MyContext } from "../context/UserProvider";

export function useFormularioLogica(formularioId = 1) {
  const [formulario, setFormulario] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typeButton, setTypeButton] = useState("Próximo");
  const [respostasByCampoId, setRespostasByCampoId] = useState({}); // { [campo_id]: "valor" }
  const {setFormularioConcluido, formularioConcluido } = useContext(MyContext); // exemplo de uso de contexto, caso queira associar respostas a um usuário logado
  const [codigo] = useState('initialCode');
  const [copiado, setCopiado] = useState(false);
  // carrega formulário
  useEffect(() => {
    const controller = new AbortController();

    getFormularioById(formularioId, controller.signal)
      .then((data) => {
        // garante ordenação (se vier ordenado da API, ok, mas não custa)
        const camposOrdenados = [...(data.campos || [])].sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0));
        setFormulario({ ...data, campos: camposOrdenados });
        console.log("Formulário carregado:", data);
        setCurrentIndex(0);
        setTypeButton(camposOrdenados.length <= 1 ? "Concluir" : "Próximo");
      })
      .catch(console.error);

    return () => controller.abort();
  }, [formularioId]);

  const campos = formulario?.campos || [];

  const campoAtual = campos[currentIndex] || null;

  const changeTypeButton = (index) => {
    if (index === campos.length - 1) setTypeButton("Concluir");
    else setTypeButton("Próximo");
  };

  const setRespostaAtual = (valor) => {
    if (!campoAtual) return;
    setRespostasByCampoId((prev) => ({
      ...prev,
      [campoAtual.campo_id]: valor,
    }));
  };

  const proximo = () => {
    if (currentIndex < campos.length - 1) {
      const novo = currentIndex + 1;
      setCurrentIndex(novo);
      changeTypeButton(novo);
    }
  };

  const anterior = () => {
    if (currentIndex > 0) {
      const novo = currentIndex - 1;
      setCurrentIndex(novo);
      changeTypeButton(novo);
    }
  };

  // opcional: filtra número se tiver pattern onlyNumbers
  const isCampoNumerico = useMemo(() => {
    if (!campoAtual?.validacoes) return false;
    return campoAtual.validacoes.some(v => v.validacao_comando === "pattern" && v.validacao_nome === "onlyNumbers");
  }, [campoAtual]);

  const concluir = async () => {
    // transforma para o formato que sua API espera
    const respostas = campos.map((c) => ({
      campo_id: c.campo_id,
      resposta_valor: respostasByCampoId[c.campo_id] ?? "",
    }));

    try {
      const result = await enviarFormulario(formularioId, respostas);
      console.log("Envio criado:", result.envio_id);
      setFormularioConcluido(true);
      return result;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const initialCode = useMemo(() => {
    // exemplo: gera um código no formato XXXX-1234
    const letters = "ABCDEFGHJKLMNPQRSTUVWXYZ";
    const part1 = Array.from({ length: 4 }, () => letters[Math.floor(Math.random() * letters.length)]).join("");
    const part2 = String(Math.floor(1000 + Math.random() * 9000));
    return `${part1}-${part2}`;
  }, []);



  const copiarCodigo = async () => {
    try {
      await navigator.clipboard.writeText(codigo);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1400);
    } catch (e) {
      // fallback simples
      const temp = document.createElement("input");
      temp.value = codigo;
      document.body.appendChild(temp);
      temp.select();
      document.execCommand("copy");
      document.body.removeChild(temp);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1400);
    }
  };

  return {
    formulario,
    campos,
    campoAtual,
    typeButton,
    currentIndex,
    respostaAtual: campoAtual ? (respostasByCampoId[campoAtual.campo_id] ?? "") : "",
    setRespostaAtual,
    setCurrentIndex,
    changeTypeButton,
    proximo,
    anterior,
    concluir,
    isCampoNumerico,
    copiarCodigo,
    codigo,
    copiado,
    formularioConcluido,
    setFormularioConcluido,
  };
}
